export default __webpack_public_path__ + "static/media/icon-filetype-pdf.50e2781b.svg";